import React from 'react';
import { ScrollView, View, Appearance, Linking } from 'react-native';
import { SearchNormal1 } from 'iconsax-react-native';
import axios from 'axios';
import { TextInput, Text, TouchableRipple } from 'react-native-paper';
import { MotiView } from 'moti';
import { Skeleton } from 'moti/skeleton';
import { getLocales } from 'expo-localization';
import { MainContext } from '../../contexts/MainContext';
import Spacer from '../../components/Spacer/Spacer';

export default function Search({}){
  const myContext = React.useContext(MainContext);
  const [searchLoading, setSearchLoading] = React.useState(false);
  const [searchValue, setSearchValue] = React.useState('');
  const colorScheme = Appearance.getColorScheme();
  const [searchedData, setSearchedData] = React.useState([]);
  const deviceLanguage = getLocales()[0].languageCode;  

  const searchData = (value) => {
    if(value.length >= 3) {
      setSearchLoading(true);
      axios.all([
        axios.post(`/panel/ads/search`, {search: value}),
      ])
      .then(axios.spread((response) => {
        if(response.data.data) {
          setSearchedData(response.data.data);
        }
      }))
      .catch(myContext.handleAxiosError)
      .finally(() => setSearchLoading(false));
    }
  }

  const skeletonContent = (isSmall = false) => {
    return (
      <MotiView
        transition={{
          type: 'timing',
        }}
        style={{ flex: 1, justifyContent: 'space-between', paddingVertical: !isSmall ? 16 : 0, paddingHorizontal: !isSmall ? 18 : 0 }}
        animate={{ backgroundColor: colorScheme === 'dark' ? '#000000' : '#ffffff' }}
      >
        <View>
          <Skeleton colorMode={colorScheme} width={'100%'} height={50} />
          <Spacer height={8} />
          <Skeleton colorMode={colorScheme} width={'100%'} height={50} />
          <Spacer height={8} />
          <Skeleton colorMode={colorScheme} width={'100%'} height={50} />
          <Spacer height={8} />
          <Skeleton colorMode={colorScheme} width={'100%'} height={50} />
          <Spacer height={8} />
          <Skeleton colorMode={colorScheme} width={'100%'} height={50} />
          <Spacer height={8} />
          <Skeleton colorMode={colorScheme} width={'100%'} height={50} />
        </View>
      </MotiView>
    );
  }

  const displayAdsButton = async (id) => {
    const supported = await Linking.canOpenURL(`https://40lsoton.ir/ad/${id}`);

    if (supported) {
      await Linking.openURL(`https://40lsoton.ir/ad/${id}`);
    } else {
      Alert.alert(`Don't know how to open this URL`);
    }
  };

  return (
    <View style={{ flex: 1, paddingVertical: 16, backgroundColor: '#fcfcfd' }}>
      <View style={{ paddingHorizontal: 18 }}>
        <TextInput 
          label="جستجو کنید"
          placeholder="جستجو بر اساس کد ملک، نام آگهی و یا منطقه"
          mode="outlined"
          activeOutlineColor="#c6c5c4"
          value={searchValue}
          onChangeText={text => {searchData(text); setSearchValue(text)}}
          right={deviceLanguage === 'fa' ? <TextInput.Icon icon={() => <SearchNormal1 size="20" color="#666666" variant="Outline"/>} /> : null}
          left={deviceLanguage === 'fa' ? null : <TextInput.Icon icon={() => <SearchNormal1 size="20" color="#666666" variant="Outline"/>} />}
          style={{ marginBottom: 16, fontSize: 12, color: '#BFC0C5' }}
        />
        {/* <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: 18 }}>
          <View style={{ flexDirection: 'row', alignItems: 'center' }}>
            <SearchStatus size="24" color="#353535"/>
            <Text style={{ marginLeft: 4, fontSize: 12, color: '#353535' }}>تاریخچه جستجو</Text>
          </View>
          <TouchableRipple borderless onPress={() => {}} style={{ width: 36, height: 36, alignItems: 'center', justifyContent: 'center', borderRadius: 36 }}><Trash size="24" color="#292D32"/></TouchableRipple>
        </View> */}
      </View>
      <ScrollView contentContainerStyle={{ backgroundColor: '#fcfcfd' }}>
        {
          searchLoading ? 
            skeletonContent()
          :
            Object.keys(searchedData).length > 0 &&
            Object.values(searchedData).map((item, i) => (
              <TouchableRipple rippleColor="rgba(0, 0, 0, .04)" onPress={() => displayAdsButton(item.postId)} key={i} style={{ paddingHorizontal: 18, paddingVertical: 4, flexDirection: 'row', alignItems: 'center', marginBottom: 10 }}>
                <>
                  <SearchNormal1 size="18" color="#353535" variant="Outline"/>
                  <View style={{ marginLeft: 12 }}>
                    <Text style={{ fontSize: 12, color: '#353535', marginBottom: 2 }}>{item.title}</Text>
                    <Text style={{ fontSize: 10, color: '#ADADAD' }}>کدآگهی: {item.postId}</Text>
                  </View>
                </>
              </TouchableRipple>
            ))
        }
      </ScrollView>
    </View>
  );
};